import api from "../services/api";

/**
 * Update the quantity and totalPrice of a cart item in the backend.
 * @param {Object} item - The cart item object (must include _id or productId and unitPrice).
 * @param {number} newQuantity - The updated quantity.
 */
export const updateCartItemQuantity = async (item, newQuantity) => {
  if (!item || !item._id || !item.unitPrice) {
    console.error("❌ Missing item data for cart update.");
    return;
  }

  try {
    const response = await api.post("/cart/update", {
      productId: item._id,
      quantity: newQuantity,
      totalPrice: item.unitPrice * newQuantity,
    });

    console.log("✅ Cart item updated:", response.data);
    return response.data;
  } catch (err) {
    console.error("❌ Failed to update cart item:", err);
    throw err;
  }
};
